import { httpAuthRequest } from '@/services'

const state = {
    miscellaneous: [],
    miscellaneousDraft: [],
    games: [],
    selectedItems: []
}

const actions = {

    async getMiscellaneous({ commit }) {
        const response = await httpAuthRequest('get', '/items/')
        if (response.success) commit('SET_MISCELLANEOUS', response.data)
        return response.success
    },

    async getMiscellaneousDraft({ commit }) {
        const response = await httpAuthRequest('get', '/items/?status=DR')
        if (response.success) commit('SET_MISCELLANEOUS_DRAFT', response.data)
        return response.success
    },

    async editItem({ commit }, payload) {
        const response = await httpAuthRequest('put', `items/${payload.item_id}/`, payload)
        if (response.success) commit('UPDATE_ITEM', response.data)
        return response
    },

    async editGame({ commit }, payload) {
        const response = await httpAuthRequest('put', `games/${payload.item_id}/`, payload)
        if (response.success) commit('UPDATE_ITEM', response.data)
        return response
    },

    async createMiscellaneous({ commit }, payload) {
        const response = await httpAuthRequest('post', 'items/', payload)
        if (response.success) commit('ADD_ITEM', response.data)
        return response
    },

    
    async createGames({ commit }, payload) {
        const response = await httpAuthRequest('post', 'games/', payload)
        if (response.success) commit('ADD_ITEM', response.data)
        return response
    },

    async getSearchMiscellaneous({ commit }, payload) {
        const response = await httpAuthRequest('get', '/items/?search=' + payload)
        if (response.success) commit('SET_MISCELLANEOUS', response.data)
        return response.success
    },

    async getSearchMiscellaneousProfile({ commit }, payload) {
        const response = await httpAuthRequest('get', '/items/?search=' + payload.tempFilter + "&profile=" + payload.profileId + '&list=' + payload.list)
        if (response.success) commit('SET_MISCELLANEOUS', response.data)
        return response.success
    },

    async getGames({ commit }) {
        const response = await httpAuthRequest('get', '/games/')
        if (response.success) commit('SET_GAMES', response.data)
        return response.success
    }
}

const mutations = {
    SET_MISCELLANEOUS(state, items) {
        state.miscellaneous = items.results
    },

    SET_MISCELLANEOUS_DRAFT(state, items) {
        state.miscellaneousDraft = items.results
    },
    REMOVE_DRAFT_ITEM(state, item) {
        state.miscellaneousDraft = state.miscellaneousDraft.filter(e => e.item_id != item.item_id)
    },

    SET_GAMES(state, items) {
        state.games = items.results
    },
    UPDATE_ITEM(state, item) {
        state.miscellaneous = state.miscellaneous.filter(e => e.item_id != item.item_id)
        state.miscellaneous.push(item)
    },
    ADD_ITEM(state, item) {
        state.miscellaneous.push(item)
    },

    RESET_STATE(state) {
        state.miscellaneous = []
        state.games = []
    },

    SET_SELECTED_ITEMS(state, selection) {
        state.selectedItems = selection
    }
}

export default {
    state,
    actions,
    mutations
}
